import 'babel-polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'vuetify/dist/vuetify.min.css'
import 'assets/style.scss'
import vuetify from './plugins/vuetify';
import { sync } from 'vuex-router-sync'
import store from '@/store/store'
import * as VueLoaders from 'vue-loaders'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vue-loaders/dist/vue-loaders.css'
import VueSweetalert2 from 'vue-sweetalert2'
import LightTimeline from 'vue-light-timeline'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.config.productionTip = false
Vue.config.performance = true
sync(store, router)
Vue.use(VueLoaders)
Vue.use(VueSweetalert2)
Vue.use(LightTimeline)
Vue.use(VueObserveVisibility)

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App),
}).$mount('#app')